import {PortalVariablesEnum} from '@app/common/enums/portal-variables.enum';

export const PORTAL_VARIABLES_PRESETS = {
  [PortalVariablesEnum.MainColor]: '',
  [PortalVariablesEnum.SectionBackgroundColor]: '',
  [PortalVariablesEnum.ButtonColor]: '',
  [PortalVariablesEnum.AccentColor]: '',
};
